import { render } from "./index.vue?vue&type=template&id=7c9e0202"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/tag/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c9e0202"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c9e0202', __exports__)) {
    api.reload('7c9e0202', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=7c9e0202", () => {
    api.rerender('7c9e0202', render)
  })

}


export default __exports__